var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "z-link",
      class: _vm.classObject,
      attrs: {
        href: _vm.href,
        target: _vm.external || _vm.blank ? "_blank" : false,
        download: _vm.setDownloadFile() ? _vm.downloadTitle : false,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      (_vm.customIcon || _vm.iconName) && _vm.position === "left"
        ? _c("z-icon", {
            attrs: {
              name: _vm.customIcon || _vm.iconName,
              width: _vm.width,
              height: _vm.height,
            },
          })
        : _vm._e(),
      _c("span", [_vm._t("default")], 2),
      (_vm.customIcon || _vm.iconName) && _vm.position === "right"
        ? _c("z-icon", {
            attrs: {
              name: _vm.customIcon || _vm.iconName,
              width: _vm.width,
              height: _vm.height,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }